import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

function renderApp() {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

function renderChunkError() {
  root.render(
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      color: '#0f172a',
      fontFamily: 'Manrope, Arial, sans-serif',
      textAlign: 'center',
      padding: 32
    }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16 }}>Mise à jour disponible</h1>
      <p style={{ fontSize: 18, marginBottom: 24 }}>Une nouvelle version du site est disponible.<br/>Veuillez rafraîchir la page pour continuer.</p>
      <button onClick={() => window.location.reload(true)} style={{
        background: '#ea580c', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 32px', fontSize: 18, fontWeight: 600, cursor: 'pointer', boxShadow: '0 2px 8px #ea580c22'
      }}>Rafraîchir</button>
    </div>
  );
}

// Catch global pour ChunkLoadError (erreur de cache/déploiement)
window.addEventListener('error', function (e) {
  if (e?.error?.name === 'ChunkLoadError' || (e?.message && e.message.includes('ChunkLoadError'))) {
    renderChunkError();
  }
});

// Pour les promesses non catchées (import dynamique)
window.addEventListener('unhandledrejection', function (e) {
  if (e?.reason?.name === 'ChunkLoadError' || (e?.reason?.message && e.reason.message.includes('ChunkLoadError'))) {
    renderChunkError();
  }
});

renderApp();
